<!--<div class="{{class}} {{animation}}" style="&#45;&#45;order:1.5">-->
<!--  <div class="loader faded">-->
<!--    <div class="big-circle">-->
<!--      <div class="small-circle"></div>-->
<!--    </div>-->
<!--  </div>-->
<!--</div>-->

<ng-http-loader
        [backdrop]="false"
        [backgroundColor]="'#CABC2B'"
        [debounceDelay]="100"
        [extraDuration]="300"
        [minDuration]="300"
        [opacity]="'.6'"
        [filteredHeaders]="['ngLoader']"
        [backdropBackgroundColor]="'#777777'"
        [spinner]="spinkit.skChasingDots">
</ng-http-loader>
